import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Slider, Stack } from "@mui/material";
import React from "react";
import { useFormatting } from "../formatting/useFormatting.js";
import { FormattedPriceInput } from "./FormattedPriceInput.js";
import { useDebouncedSync } from "../hooks/useDebouncedSync.js";
export function PriceSliderWithInput({ label, labelMin, labelMax, range, value, setValue, debounceMs, }) {
    const { getFormattedPrice } = useFormatting();
    const [min, max] = range;
    const passedValue = React.useMemo(() => [value[0] ?? min, value[1] ?? max], [max, min, value]);
    const isRangeEqual = React.useCallback((v1, v2) => {
        return ((v1?.[0] ?? min) === (v2?.[0] ?? min) &&
            (v1?.[1] ?? max) === (v2?.[1] ?? max));
    }, [max, min]);
    const [internalValue, setInternalValue] = useDebouncedSync({
        externalValue: passedValue,
        setExternalValue: setValue,
        isEqualValues: isRangeEqual,
        debounceMs,
    });
    const handleSliderChange = (event, newValue) => {
        if (!Array.isArray(newValue))
            throw new Error(`Invalid value for range slider: ${newValue}`);
        const [newMin, newMax] = newValue;
        setInternalValue([newMin, newMax]);
    };
    const handleMinInputChange = (value) => {
        setInternalValue([value ?? min, internalValue[1]]);
    };
    const handleMaxInputChange = (value) => {
        setInternalValue([internalValue[0], value ?? max]);
    };
    return (_jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [_jsx(Box, { flexBasis: "25%", flexGrow: 1, flexShrink: 1, children: _jsx(FormattedPriceInput, { label: labelMin, value: internalValue[0], min: 0, 
                    // min={min}
                    // max={max}
                    // size="extra-small"
                    onChange: handleMinInputChange, inputProps: {
                        step: 1,
                        "aria-labelledby": "input-slider",
                    }, variant: "standard" }) }), _jsx(Box, { flexBasis: "50%", minWidth: "80px", maxWidth: "150px", flexGrow: 2, flexShrink: 2, children: _jsx(Slider
                // size={"small"}
                , { 
                    // size={"small"}
                    value: internalValue, step: 1, onChange: handleSliderChange, valueLabelDisplay: "auto", "aria-labelledby": "input-slider", getAriaLabel: () => label, getAriaValueText: value => getFormattedPrice(value) ?? "", valueLabelFormat: value => getFormattedPrice(value) ?? "", track: "normal", min: min, max: max }) }), _jsx(Box, { flexBasis: "25%", flexGrow: 1, flexShrink: 1, children: _jsx(FormattedPriceInput, { label: labelMax, value: internalValue[1], min: 0, 
                    // min={min}
                    // max={max}
                    // size="extra-small"
                    onChange: handleMaxInputChange, inputProps: {
                        step: 1,
                        "aria-labelledby": "input-slider",
                    }, variant: "standard" }) })] }));
}
//# sourceMappingURL=PriceSliderWithInput.js.map